<template>
  <div
    id="app"
    class="app-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppMain',
  metaInfo() {
    return {
      titleTemplate: (titleChunk) => {
        const title = this.$t('pages.meta.title');
        return (titleChunk ? `${titleChunk} | ${title}` : title);
      },
    };
  },
};
</script>

<style>
html {
  min-width: 640px;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
}

body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  background: #f0f0f0;
  font-family:
    Helvetica Neue,
    Helvetica,
    PingFang SC,
    Hiragino Sans GB,
    Microsoft YaHei,
    Arial,
    sans-serif;
}

.app-main {
  width: 100%;
  height: 100%;
}

.ivu-btn-text:focus {
  box-shadow: none;
}

.ivu-select-multiple.ivu-select-small .ivu-select-input {
  height: 22px;
  line-height: 22px;
}

.spacer, .flex-grow {
  flex-grow: 1 !important;
}

.text-capitalize {
  text-transform: capitalize;
}

.text-capitalize-first {
  display: inline-block;
}
.text-capitalize-first:first-letter {
  text-transform: uppercase;
}

.ivu-select-multiple .ivu-tag {
  max-width: 100%;
  white-space: nowrap;
}

.ivu-select-multiple .ivu-tag .ivu-tag-text{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 16px);
}

.ivu-select-multiple .ivu-tag .ivu-icon {
  top: -1px;
}


</style>
